import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0m0 22.4C6.3 22.4 1.6 17.7 1.6 12S6.3 1.6 12 1.6 22.4 6.3 22.4 12 17.7 22.4 12 22.4" }, null, -1),
    _createElementVNode("path", { d: "M17.9 11.1h-5.1V4.3c0-.4-.4-.8-.8-.8s-.8.4-.8.8v8.4h6.7c.4 0 .8-.4.8-.8s-.3-.8-.8-.8" }, null, -1)
  ])))
}
export default { render: render }